import './Menu.scss';

import React, {useEffect, useState} from 'react';
import {useLocation} from 'react-router-dom';

import helpers from '../../utils/helpers';
import MenuItem from './MenuItem';
import menuService from './menuService';
import MobileMenu from './MobileMenu';
import PwaInstallMenuItem from './PwaInstallMenuItem';

const menuItemsMap = {
    OBJECTS: ['objects', 'organization', 'building-profile', 'room-profile', 'diagnostic'],
    MAP: ['map'],
    'USER-OBJECTS': ['user-objects', 'room-profile'],
    'DATA-COLLECTORS': ['data-collectors'],
    USERS: ['users', 'users-objects'],
    REPORTS: ['reports'],
    SERVICES: ['services'],
    SETTINGS: ['settings'],
    GATEWAYS: ['gateways'],
};

const Menu = ({isMobileMenuOpened, onMobileMenuClose}) => {
    const {pathname} = useLocation();
    const [activeItem, setActiveItem] = useState();

    const menuItems = menuService.getMenuItems();

    const onItemClick = (item) => {
        setActiveItem(item.type);
        onMobileMenuClose();
        helpers.runFunction(item?.onClick);
    };

    useEffect(() => {
        const formattedPathName = pathname.split('/')[1];

        let menuType = null;

        for (const item of menuItems) {
            const type = item.type;

            if (menuItemsMap[type].includes(formattedPathName)) {
                menuType = type;
                break;
            }
        }

        setActiveItem(menuType);
    }, [menuItems, pathname]);

    useEffect(() => {
        const desktopQuery = window.matchMedia('(min-width: 768px)');
        const handleViewportChange = () => {
            if (desktopQuery.matches) onMobileMenuClose();
        };

        handleViewportChange();
        desktopQuery.addEventListener('change', handleViewportChange);

        return () => desktopQuery.removeEventListener('change', handleViewportChange);
    }, [onMobileMenuClose]);

    return (
        <>
            <MobileMenu
                isOpen={isMobileMenuOpened}
                items={menuItems}
                activeItem={activeItem}
                onItemClick={onItemClick}
                onClose={onMobileMenuClose}
            />
            <aside className='hidden min-w-[101px] bg-jaguar md:block'>
                <div
                    className='sticky top-[var(--mobile-header-height)] flex flex-col'
                    style={{
                        height: 'calc(var(--mobile-viewport-height, 100vh) - var(--mobile-header-height, 67px) - var(--mobile-safe-bottom, 0px))',
                    }}
                >
                    <div className='pt-[37px] overflow-y-auto'>
                        {menuItems?.map((item) => (
                            <MenuItem
                                isActive={item.type === activeItem}
                                onClick={() => onItemClick(item)}
                                href={item.href}
                                key={item.type}
                                menuType={item.type}
                                value={item.value}
                            />
                        ))}
                        <PwaInstallMenuItem onMobileMenuClose={onMobileMenuClose} />
                    </div>
                    <div className='mt-auto shrink-0'>
                        <div className='px-4 py-2 text-santa text-12 select-none pointer-events-none'>
                            <p className='whitespace-nowrap'>Версія 2.3.0</p>
                        </div>
                    </div>
                </div>
            </aside>
        </>
    );
};

export default Menu;
